import React from 'react'
import "../CompStyles/Seperator.css"

function Seperator() {
  return (
    <div className='seperator'></div>
  )
}

export default Seperator